<template>
    <div class="perk-shop tmp-block">
        <div class="title-contents">
            <div class="icon-holder">
                <img src="@/assets/icons/crown.svg" alt="">
            </div>
            <h2>Покупка доната</h2>
        </div>
        <sale/>
        <form action="" @submit.prevent="submit">
            <text_field placeholder="Никнейм" v-model.trim="nickname"/>
            <div class="error-block" v-if="validate && !nickname">Введите свой никнейм</div>
            <dropdown placeholder="Выберите товар" :optionList="products" v-model="productId"/>
            <div class="error-block" v-if="validate && !product">Выберите привилегию</div>
            <label class="btn-buy" :class="{disabled: disabledBtn}">
                <large_button :class="{disabled: disabledBtn}" type="submit"/>
                <span class="title">{{buttonText}}</span>
            </label>
        </form>
    </div>
</template>

<script>
    import text_field from '@/elements/text_field.vue'
    import dropdown from '@/elements/dropdown.vue'
    import large_button from '@/elements/large_button.vue'
    import sale from '@/components/main/sale.vue'
    import _debounce from 'lodash/debounce'
    import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

    export default {
        name: "perk_shop",
        components:{
            text_field,
            dropdown,
            large_button,
            sale,
        },
        data:()=>({
            nickname: '',
            productId: false,
            pendingSurcharge: false,
            validate: false
        }),
        watch: {
            nickname(){
                this.pendingSurcharge = true;
                this.resetSurcharge();
                this.getUserSurcharge();
            }
        },
        computed: {
            product(){
                for (let group in this.products) {
                    const product = this.products[group].find(({id})=>id === this.productId);
                    if(product) return product;
                }
            },
            sale(){
                if(this.discount) return this.discount.discount;
                else return 0;
            },
            price(){
                if(this.product) {
                    if(this.product.surcharge) return this.considerDiscount(this.product.price - this.surcharge);
                    else return this.product.price;
                }
                return false;
            },
            validNick(){
                return this.nickname.length && new RegExp('^[a-zA-Z0-9-_\.]+$|i').test(this.nickname);
            },
            disabledBtn(){
                return !(this.product && this.validNick && this.price > 0 && this.product); // both selected or no product
                // return this.price <= 0 || !this.nickname.length || this.pendingSurcharge || Object.values(this.pending).some(el=>el);
            },
            buttonText(){
                if(!this.nickname.length ) return "Введите ник";
                else if(!this.validNick) return "Недопустимый ник";
                else if(this.price === false) return "Выберите товар";
                else return this.price > 0 ? `Купить за ${this.price} ₽` : "Недоступно";
            },
            ...mapState('main', ['products', 'discount', 'surcharge', 'pending'])
        },
        methods: {
            considerDiscount(price){
                return price;
                /*if(this.sale) return price*this.sale/100;
                else return price;*/
            },
            getUserSurcharge:  _debounce(function () {
                this.pendingSurcharge = false;
                if(!this.nickname.trim().length) return;
                this.getSurcharge({
                    params: {
                        login: this.nickname.trim()
                    }
                })
            }, 300),
            submit() {
                this.validate = true;
                this.buy({params: {
                        login: this.nickname,
                        product: this.product.id
                    }})
                .then(({data})=>{
                    if(data && data.length) location.href = data;
                    else return Promise.reject('Ошибка сервера');
                })
                .catch((err) => {
                    this.putNotificationErr(err.message || err);
                });
            },
            ...mapMutations('notifications', ['putNotificationErr']),
            ...mapMutations('main', ['resetSurcharge']),
            ...mapActions('main', ['getProducts', 'getSurcharge', 'buy'])
        },
        created() {
            if(!this.products.length || !this.pending.products){
                this.getProducts();
            }
        }
    }
</script>

<style scoped lang="scss">
    .perk-shop {
        .error-block {
            margin-top: -10px;
            margin-bottom: 12px;
        }

        .btn-buy {
            position: relative;
            display: block;
            width: 100%;
            height: 56px;
            margin: 0;
            cursor: pointer;

            &.disabled {
              cursor: default;
            }

            button {
                width: 100%;
            }

            .title {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                display: flex;
                align-items: center;
                justify-content: center;

                color: white;
                font-weight: bold;
                font-size: 16px;
                line-height: 19px;
                letter-spacing: .12em;
                text-transform: uppercase;
                text-shadow: $text_shadow_blue;
            }
        }
    }
</style>
